import { render, staticRenderFns } from "./addPatch.vue?vue&type=template&id=cd116c12&"
import script from "./addPatch.vue?vue&type=script&lang=js&"
export * from "./addPatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports